<!-- Liste des archivages du lot -->
<list-view [liste]="listeSynchro" *ngIf="listeSynchro"></list-view>

<!-- Liste des NDF du lot -->
<list-view [liste]="listeNdf" *ngIf="listeNdf"></list-view>

<!-- Boutons d'action -->
<floating-button [listeActions]="listeActions"></floating-button>
